"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = dialogs;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("../components");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dialogs(openCallback, closeCallback) {
  return {
    prompt: function prompt(question) {
      return new _bluebird2.default(function (resolve, reject) {
        var component = _react2.default.createElement(_components.Prompt, { question: question, onCloseYes: resolve, onCloseNo: reject });

        openCallback(component);
      }).catch(function (err) {}).finally(closeCallback);
    },

    custom: function custom(component, props) {
      return new _bluebird2.default(function (resolve, reject) {
        openCallback(_react2.default.cloneElement(component, (0, _extends3.default)({}, props, {
          onCloseYes: resolve,
          onCloseNo: reject
        })));
      }).catch(function (err) {}).finally(function () {
        closeCallback();
        props.afterClose && props.afterClose();
      });
    }
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/dialogs.jsx
// module id = 2871
// module chunks = 0